module.exports = __webpack_public_path__ + "img/playVideo.52a06d04.png";